import {
  UNIFIED_DASHBOARD_PATH,
  MARKET_PULSE_HUB_PATH,
} from "components/allInOneDashboard/constants/productRouteMap";

/** Desktop web top nav + mobile-web side drawer (same items/order). */
export const TOP_NAV_ITEMS = [
  { id: "explore", label: "Explore", path: UNIFIED_DASHBOARD_PATH },
  { id: "blogs", label: "Blogs", path: "/customer/blogs" },
  { id: "profile", label: "Profile", path: "/customer/profile" },
  { id: "marketPulse", label: "Market Pulse", path: MARKET_PULSE_HUB_PATH },
];
